<template>
  <header class="header">
    <div class="container">
      <div class="header-content">
        <div class="logo">
          <router-link to="/">
            <img src="/img/logo.png" alt="FASA Transport" v-if="false">
            <h1 v-else>FASA <span>Transporters</span></h1>
          </router-link>
        </div>
        <nav :class="{ 'active': mobileMenuOpen }">
          <ul>
            <li><router-link to="/" @click="closeMobileMenu">Home</router-link></li>
            <li><router-link to="/about" @click="closeMobileMenu">About Us</router-link></li>
            <li><router-link to="/services" @click="closeMobileMenu">Services</router-link></li>
            <li><router-link to="/contact" @click="closeMobileMenu">Contact</router-link></li>
          </ul>
        </nav>
        <div class="mobile-toggle" @click="toggleMobileMenu">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      mobileMenuOpen: false
    }
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  background-color: white;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
  
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
  }
  
  .logo {
    a {
      text-decoration: none;
      color: var(--secondary-color);
    }
    
    h1 {
      font-size: 24px;
      font-weight: 700;
      margin: 0;
      
      span {
        color: var(--primary-color);
      }
    }
  }
  
  nav {
    ul {
      display: flex;
      list-style: none;
      
      li {
        margin-left: 25px;
        
        a {
          text-decoration: none;
          color: var(--secondary-color);
          font-weight: 500;
          transition: all 0.3s ease;
          
          &:hover, &.router-link-active {
            color: var(--primary-color);
          }
        }
      }
    }
  }
  
  .mobile-toggle {
    display: none;
    flex-direction: column;
    cursor: pointer;
    
    span {
      width: 25px;
      height: 3px;
      background-color: var(--secondary-color);
      margin: 3px 0;
      transition: all 0.3s ease;
    }
  }
  
  @media (max-width: 768px) {
    .mobile-toggle {
      display: flex;
    }
    
    nav {
      position: absolute;
      top: 70px;
      left: 0;
      right: 0;
      background-color: white;
      box-shadow: 0 2px 10px rgba(0,0,0,0.1);
      padding: 20px;
      transform: translateY(-150%);
      transition: all 0.3s ease;
      
      &.active {
        transform: translateY(0);
      }
      
      ul {
        flex-direction: column;
        
        li {
          margin: 15px 0;
          margin-left: 0;
        }
      }
    }
  }
}
</style>